/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';

import {Box, Button, Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui';

const Suggestions = ({suggestions, closeAndNavigate}) => {
  if (!suggestions) {
    return null;
  }

  return (
    <Stack data-testid="sf-suggestion" spacing={0}>
      <Box mx="-16px">
        {suggestions.map((suggestion, idx) => (
          <Button
            key={idx}
            fontSize="md"
            marginTop={0}
            variant="menu-link"
            width="full"
            onMouseDown={() => closeAndNavigate(suggestion.link)}
          >
            <Text
              dangerouslySetInnerHTML={{__html: suggestion.name}}
              fontWeight="400"
            />
          </Button>
        ))}
      </Box>
    </Stack>
  );
};

Suggestions.propTypes = {
  suggestions: PropTypes.array,
  closeAndNavigate: PropTypes.func,
};

export default Suggestions;
